import React from 'react'

import { APP_MARKET_PLACE, NEUTRAL_COLOURS } from 'constants/colors'

import { createTypeFromEnumValues } from 'utils/typescript'

import { Spinner, Typography } from 'components'

import {
  StyledChip,
  StyledChipContainer,
  StyledContainer,
  StyledHeaderContainer,
  StyledLogo,
} from './AppMarketplaceCardStyled'
import { APP_MARKETPLACE_STATUS, APP_MARKETPLACE_STATUS_LABEL } from '../AppMarketplaceConstants'

interface AppMarketplaceCardProps {
  appLogo: string
  appName: string
  description: string
  isStatusLoading?: boolean
  specialOfferText?: string
  status?: createTypeFromEnumValues<APP_MARKETPLACE_STATUS>
  title?: string
  titleColor?: string
  to: string
}

const AppMarketplaceCard: React.FC<AppMarketplaceCardProps> = ({
  appLogo,
  appName,
  description,
  isStatusLoading,
  specialOfferText,
  status,
  title,
  titleColor,
  to,
}) => {
  let showOfferText = true

  if (status && 'connected' === status) {
    showOfferText = false
  }

  return (
    <StyledContainer to={to}>
      <StyledHeaderContainer>
        <StyledLogo src={appLogo} />
        <StyledChipContainer>
          {status && (
            <StyledChip
              $backgroundColor={'not_connected' === status && NEUTRAL_COLOURS.GRAY_TERTIARY}
              $color={'connected' === status && APP_MARKET_PLACE.CONNECTED_TEXT}
              $alignRight
            >
              {isStatusLoading
                ? <Spinner size="small" />
                : <Typography fontSize={12}>{APP_MARKETPLACE_STATUS_LABEL[status]}</Typography>}
            </StyledChip>
          )}
          {specialOfferText && showOfferText && !isStatusLoading && (
            <StyledChip
              $backgroundColor={APP_MARKET_PLACE.SPECIAL_OFFER}
              $color={APP_MARKET_PLACE.SPECIAL_OFFER_TEXT}
              $alignRight
            >
              <Typography fontSize={12} bold>{specialOfferText}</Typography>
            </StyledChip>
          )}
        </StyledChipContainer>
      </StyledHeaderContainer>
      <Typography fontSize={20} margin="16px 0 0" bold>
        {appName}
      </Typography>
      <Typography color={titleColor} fontSize={14} fontWeight={500} margin="8px 0 0">
        {title}
      </Typography>
      <Typography color={NEUTRAL_COLOURS.GRAY} fontSize={14} margin="8px 0 0">
        {description}
      </Typography>
    </StyledContainer>
  )
}

export default AppMarketplaceCard
